import { render, staticRenderFns } from "./TreineBanners.vue?vue&type=template&id=46a39e1e&"
import script from "./TreineBanners.vue?vue&type=script&lang=js&"
export * from "./TreineBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports